import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import Error from './components/Error';
import ScrollToTop from './components/Helper/ScrollToTop';
import HomeOne from './components/HomeOne';
import { PrivacyPolicy, TermsOfService } from './components/Legal';
import Login from './components/Login';
import PupilApp from './components/PupilApp';
// Blog hidden for now, restore with the /news routes below
// import News from './components/News';
// import SingleNews from './components/News/SingleNews';

function Routes() {
    return (
        <Router>
            <ScrollToTop>
                <Switch>
                    <Route exact path="/" component={HomeOne} />
                    {/* <Route exact path="/news" component={News} />
                    <Route exact path="/news/single-news" component={SingleNews} /> */}
                    <Route exact path="/about-us" component={AboutUs} />
                    <Route exact path="/contact" component={Contact} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/pupil-app" component={PupilApp} />
                    {/* short link for QR codes and posts; vercel.json redirects it too */}
                    <Redirect exact from="/download" to="/" />
                    <Route exact path="/privacy-policy" component={PrivacyPolicy} />
                    <Route exact path="/terms-of-service" component={TermsOfService} />
                    <Route exact path="/error" component={Error} />
                    <Route component={Error} />
                </Switch>
            </ScrollToTop>
        </Router>
    );
}

export default Routes;
